var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-avatar",
      class: "-" + _vm.size,
      style: { backgroundImage: "url(" + _vm.image + ")" }
    },
    [
      !_vm.image
        ? _c("img", {
            staticClass: "placeholder",
            attrs: {
              src: require("../../assets/img/userPlaceholder.svg"),
              alt: _vm.abreviation
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.changeImage
        ? _c("c-button", {
            staticClass: "change",
            attrs: { icon: "camera3", size: "md" },
            on: {
              click: function($event) {
                return _vm.$emit("change-image")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c157374", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c157374","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CAvatar.vue
// module id = 2171
// module chunks = 1610